import { Component, OnInit, OnDestroy } from '@angular/core';
import { VisitingHoursDepartmentListResource } from 'app/models/VisitingHoursDepartmentListResource';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';

import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'vbn-visiting-hours',
  templateUrl: './visiting-hours.component.html',
  styleUrls: ['./visiting-hours.component.scss']
})
export class VisitingHoursComponent implements OnInit, OnDestroy{

  departments: VisitingHoursDepartmentListResource;
  errorMessage: any;
  userEmail: string;
  subscription: Subscription;
  items: any;

  constructor(private service: UtilsService, 
              private router: Router, 
              private _notificationService: NotificationsService,
              private translate: TranslateService,
              private dragula: DragulaService) {
    
      this.departments = new VisitingHoursDepartmentListResource();
      this.departments.visitingHoursDepartmentListResource = [];
      this.subscription = this.dragula.drop.subscribe(value => {
        this.changeOrderIndex(value);
      });
   }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getVisitingDepartmentsForUser();

  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getVisitingDepartmentsForUser(): void{
    this.service.get(`/admin/visitingHours/departments/getAll?userEmail=${this.userEmail}`)
    .subscribe(
      response => {
       this.departments = response;
       if(this.departments.errorCode === 10980){
        this.departments = new VisitingHoursDepartmentListResource();
        this.departments.visitingHoursDepartmentListResource = [];
       }
      },
      error => this.errorMessage = <any>error);
  }

  changeOrderIndex(value: any){
    let rid = value[1].getAttribute("department-rid")
    let oldPos = parseInt(value[1].getAttribute("index"))
    let newPos = undefined
    let departmentList = value[2].children;

    for (let i = 0; i < departmentList.length; i++) {
      let k = departmentList[i].getAttribute("department-rid")
      if (rid == k) {
        newPos = i
        break;
      }
    }

    this.service.add(`/admin/visitingHours/departments/shift?oldPosition=${oldPos}&newPosition=${newPos}&userEmail=${this.userEmail}`,null)
    .subscribe(
      response => {
       this.departments = response;
       if(this.departments.errorCode === 10985){
          forkJoin(
            [this.translate.get('Chance Order error'),
            this.translate.get('The order was not changed')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
       }else{
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Department order was changed!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
       }
       this.getVisitingDepartmentsForUser();
      },
      error => this.errorMessage = <any>error);

    setTimeout(() => {
      console.log('------');
    }, 1000);
  }

  delete(rid) {
    this.service.get(`/admin/visitingHours/departments/delete/${rid}?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          if([10982, 10983, 10984].indexOf(response.errorCode) > 0){
            forkJoin(
              [this.translate.get('Delete error'),
              this.translate.get(`The department was not deleted (${response.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }else{
            forkJoin(
              [this.translate.get('Success'),
              this.translate.get('Department was deleted!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          }
          this.getVisitingDepartmentsForUser();
        },
        error => this.errorMessage = <any>error);
  }

  edit(rid) {
    this.router.navigate(['/edit-visiting-department/' + btoa('{ "departmentRid" : "' + rid + '"}')]);
  }
}
